"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var EthereumErcTokenTransactionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(EthereumErcTokenTransactionRequest, _super);
    function EthereumErcTokenTransactionRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EthereumErcTokenTransactionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.EthereumErcTokenTransactionRequest = EthereumErcTokenTransactionRequest;
//# sourceMappingURL=EthereumErcTokenTransactionRequest.js.map